import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './CardList.module.scss';
import Card from '../Card';
import isEmpty from '../../utils/isEmpty';
import Button from '../../components/Button';

const CardList = ({ items, size, button }) => {
    const cardListClass = classNames(styles['CardList'], {
        [styles[`CardList--${size}`]]: size,
    });

    return (
        <div className={cardListClass}>
            <div className={styles['CardList__Inner']}>
                {!isEmpty(items) &&
                    items.map(
                        (
                            {
                                infoLabel,
                                title,
                                href,
                                text,
                                image,
                                type,
                                rentalTag,
                                rentalAreaName,
                                button,
                            },
                            idx
                        ) => {
                            return (
                                <Card
                                    key={idx}
                                    infoLabel={infoLabel}
                                    title={title}
                                    href={href}
                                    sizeModifier={size}
                                    text={text}
                                    image={image}
                                    type={type}
                                    rentalTag={rentalTag}
                                    rentalAreaName={rentalAreaName}
                                    button={button}
                                />
                            );
                        }
                    )}
            </div>
            {!isEmpty(button) && (
                <div className={styles['CardList__Button']}>
                    <Button {...button} />
                </div>
            )}
        </div>
    );
};

CardList.propTypes = {
    items: PropTypes.array,
    size: PropTypes.number,
    button: PropTypes.object,
};

CardList.defaultProps = {
    items: [],
    size: 100,
    button: {},
};

export default CardList;
